import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import moment from 'moment';
import buscarItinerarios from '../../actions/itinerario/buscarItinerarios';
import buscarVeiculos from '../../actions/veiculo/buscarVeiculos'
import excluirItinerarios from '../../actions/itinerario/exclurItinerario';
import buscarRotas from '../../actions/rota/buscarRotas';
import buscarMapaVeiculoItinerario from '../../actions/mapa-veiculo/buscarMapaVeiculoItinerario'
import selecionarPoltronas from '../../actions/poltrona/selecionarPoltronas'
import MapaVeiculoItinerario from './MapaVeiculoItinerario';
import selecionarAssentoItinerarioIda from '../../actions/mapa-veiculo/selecionarAssentoItinerarioIda';
import selecionarAssentoItinerarioVolta from '../../actions/mapa-veiculo/selecionarAssentoItinerarioVolta';
import adicionarPassageirosVolta from '../../actions/passageiro/adicionarPassageirosVolta';
import adicionarPassageirosIda from '../../actions/passageiro/adicionarPassageirosIda';
import { adicionarFormasPagamento } from '../../actions/viagem/adicionarFormasPagamento';
import { showErrorMsg } from '../../util/messagesUtil';
import {
    criarBloqueioPoltronasTemporario,
    liberarBloqueioPoltronasTemporario
} from '../../actions/pedido/bloqueioPoltronasTemporarioActions';
import { validaPerfis } from '../../security/Autorizacao';
import { getFiscalEmbarque } from '../../security/securityContext';
import { verificarItinerarioAtivoOuInativo } from '../../actions/itinerario/verificarItinerarioAtivoOuInativo';
import bloquearPoltronaJaMarcadoItinerarioIda from '../../actions/mapa-veiculo/bloquearPoltronaJaMarcadoItinerarioIda';
import bloquearPoltronaJaMarcadoItinerarioVolta from '../../actions/mapa-veiculo/bloquearPoltronaJaMarcadoItinerarioVolta';

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table">
        <div className="row cabecalho-desktop">
            <div className="col-lg-3 col-xl-3">Data da partida</div>
            <div className="col-lg-2 col-xl-2">Assentos disponíveis</div>
            <div className="col-lg-2 col-xl-2">Veículo</div>
            <div className="col-lg-3 col-xl-3">Rota</div>
            <div className="col-lg-2 col-xl-2">Ações</div>
        </div>
    </div>
);

export class AbaSelecionarPoltrona extends React.Component {
    constructor(props) {
        super(props);
        this.montarMapaAssentos = this.montarMapaAssentos.bind(this);
        this.state = {
            itinerarioSelecionado: null,
            textoFiltro: null,
            fileiraUmIda: [],
            fileiraDoisIda: [],
            fileiraTresIda: [],
            fileiraQuatroIda: [],
            fileiraUmVolta: [],
            fileiraDoisVolta: [],
            fileiraTresVolta: [],
            fileiraQuatroVolta: [],
        };
    }

    componentDidMount() {
        this.props.adicionarPassageirosVolta([]);
        this.props.adicionarPassageirosIda([]);
        this.props.selecionarPoltronas(null);
        this.montarMapaAssentos();
        this.props.adicionarFormasPagamento(null);
        const { bloqueios } = this.props.bloqueioPoltronasTemporario;
        if (bloqueios.length) {
            this.props.liberarBloqueioPoltronasTemporario(bloqueios.map(it => it.id))
        }
    }

    selecionarAssentoItinerarioIda(assento, fileira, sentido) {
        this.selecionarPoltrona(assento, sentido, fileira)
    }

    selecionarAssentoItinerarioVolta(assento, fileira, sentido) {
        this.selecionarPoltrona(assento, sentido, fileira)
    }

    calcularValorTotal() {
        let valorIda = 0;
        let valorVolta = 0;
        if (this.props.poltronasSelecionadas) {
            if (this.props.ida) {
                valorIda = (this.props.ida.preco * this.props.poltronasSelecionadas.filter(f => f.sentido === 'IDA').length)
            }

            if (this.props.volta) {
                valorVolta = (this.props.volta.preco * this.props.poltronasSelecionadas.filter(f => f.sentido === 'VOLTA').length)
            }
        }

        return (valorIda + valorVolta);
    }


    limparEmpresaSelecionado() {
        this.setState({ itinerarioSelecionado: null });
    }

    desmarcarPoltrona(assento, sentido, fileira) {
        if (sentido === 'IDA') {
            const passageiros = this.props.passageirosIda.filter(f => f.poltronaId !== assento.poltrona.id);
            const poltronasRemover = this.props.passageirosIda.filter(f => f.poltronaId === assento.poltrona.id).map(it => it.poltronaId);
            const bloqueios = this.props.bloqueioPoltronasTemporario.bloqueios.filter(it => poltronasRemover.includes(it.poltronaId));
            if (!bloqueios.empty) {
                this.props.liberarBloqueioPoltronasTemporario(bloqueios.map(it => it.id))
            }
            this.props.adicionarPassageirosIda(passageiros);
            this.props.selecionarAssentoItinerarioIda(assento, fileira);
        } else {
            const passageiros = this.props.passageirosVolta.filter(f => f.poltronaId !== assento.poltrona.id);
            const poltronasRemover = this.props.passageirosIda.filter(f => f.poltronaId === assento.poltrona.id).map(it => it.poltronaId);
            const bloqueios = this.props.bloqueioPoltronasTemporario.bloqueios.filter(it => poltronasRemover.includes(it.poltronaId));
            if (!bloqueios.empty) {
                this.props.liberarBloqueioPoltronasTemporario(bloqueios.map(it => it.id))
            }
            this.props.adicionarPassageirosVolta(passageiros);
            this.props.selecionarAssentoItinerarioVolta(assento, fileira);
        }
    }

    verificarSeExisteBloqueiosPoltronasTemporariosEmCache() {
        return this.props.bloqueioPoltronasTemporario.bloqueios.length > 0;
    }

    criarBloqueioTemporario(assento, sentido, fileira) {
        const ehFiscalEmbarque = validaPerfis([getFiscalEmbarque(this.props.empresaSelecionada.id)])
        const passageiro = {
            poltronaId: assento.poltrona.id,
            numeroPoltrona: assento.poltrona.numero,
            sentido,
            valor: sentido === 'IDA' ? this.props.viagemIda.preco : this.props.viagemVolta.preco,
            criancaColo: false,
        };
        const passageiros = sentido === 'IDA' ? this.props.passageirosIda : this.props.passageirosVolta;
        const novaLista = Object.assign([], passageiros);
        novaLista.push(passageiro);
        if (novaLista.length > 4 && !ehFiscalEmbarque) {
            showErrorMsg('Máximo de 4 reservas por pedido');
            return
        }
        let viagem = sentido === 'IDA' ? this.props.ida : this.props.volta;
        const patrametro = {
            poltronaId: assento.poltrona.id,
            trechoOrigemId: viagem.trechoOrigemId,
            trechoDestinoId: viagem.trechoDestinoId,
            empresaId: viagem.idEmpresa,
            itinerarioId: viagem.idItinerario
        };

        this.props.verificarItinerarioAtivoOuInativo(viagem.idItinerario)
            .then((resp) => {
                if (resp.payload.status === 200 && resp.payload.data === true || this.verificarSeExisteBloqueiosPoltronasTemporariosEmCache()) {
                    this.props.criarBloqueioPoltronasTemporario(patrametro).then((resp) => {
                        if (resp.payload.status === 200) {
                            if (sentido === 'IDA') {
                                this.props.adicionarPassageirosIda(novaLista);
                                this.props.selecionarAssentoItinerarioIda(assento, fileira);
                            } else {
                                this.props.adicionarPassageirosVolta(novaLista);
                                this.props.selecionarAssentoItinerarioVolta(assento, fileira);
                            }
                        }
                    }).catch(() => {
                        if (sentido === 'IDA') {
                            this.props.bloquearPoltronaJaMarcadoItinerarioIda(assento, fileira);
                        } else {
                            this.props.bloquearPoltronaJaMarcadoItinerarioVolta(assento, fileira);
                        }
                    });
                } else {
                    showErrorMsg('O itinerário está inativo!');
                    this.props.limparTudo();
                }
            });
    }

    marcarPoltrona(assento, sentido, fileira) {
        if (!assento.ehBloqueado) {
            if (assento.selecionado) {
                if (sentido === 'IDA') {
                    const passageiros = this.props.passageirosIda.filter(f => f.poltronaId !== assento.poltrona.id);
                    const poltronasRemover = this.props.passageirosIda.filter(f => f.poltronaId === assento.poltrona.id).map(it => it.poltronaId);
                    const bloqueios = this.props.bloqueioPoltronasTemporario.bloqueios.filter(it => poltronasRemover.includes(it.poltronaId));
                    if (!bloqueios.empty) {
                        this.props.liberarBloqueioPoltronasTemporario(bloqueios.map(it => it.id))
                    }

                    this.props.adicionarPassageirosIda(passageiros);
                    this.props.selecionarAssentoItinerarioIda(assento, fileira);
                } else {
                    const passageiros = this.props.passageirosVolta.filter(f => f.poltronaId !== assento.poltrona.id);
                    const poltronasRemover = this.props.passageirosVolta.filter(f => f.poltronaId === assento.poltrona.id).map(it => it.poltronaId);
                    const bloqueios = this.props.bloqueioPoltronasTemporario.bloqueios.filter(it => poltronasRemover.includes(it.poltronaId));
                    if (!bloqueios.empty) {
                        this.props.liberarBloqueioPoltronasTemporario(bloqueios.map(it => it.id))
                    }
                    this.props.adicionarPassageirosVolta(passageiros);
                    this.props.selecionarAssentoItinerarioVolta(assento, fileira);
                }
            } else {
                this.criarBloqueioTemporario(assento, sentido, fileira)
            }
        }
    }

    selecionarPoltrona(assento, sentido, fileira) {
        const qtdMarcadas = this.props.passageirosIda.length + this.props.passageirosVolta.length;
        if (this.props.reservasSelecionadas && qtdMarcadas > 0) {
            // Verificar se há reservas de conexão nas reservas selecionadas
            const temReservasConexao = this.props.reservasSelecionadas.some(r => 
                r.idsReservasConexao && r.idsReservasConexao.length > 0
            );
            
            // Se não for remarcação de conexão, validar quantidade de poltronas
            if (!temReservasConexao) {
                if (this.props.reservasSelecionadas.length > qtdMarcadas) {
                    this.marcarPoltrona(assento, sentido, fileira)
                } else if (assento.selecionado) {
                    this.desmarcarPoltrona(assento, sentido, fileira)
                } else {
                    showErrorMsg(`Você já selecionou ${qtdMarcadas} para remarcação.`);
                }
            } else {
                // Para reservas de conexão, permitir selecionar apenas UMA poltrona
                if (assento.selecionado) {
                    this.desmarcarPoltrona(assento, sentido, fileira)
                } else {
                    // Verificar se já existe alguma poltrona selecionada
                    const poltronasSelecionadas = sentido === 'IDA' 
                        ? this.props.passageirosIda.filter(p => p.poltronaId)
                        : this.props.passageirosVolta.filter(p => p.poltronaId);
                    
                    if (poltronasSelecionadas.length > 0) {
                        showErrorMsg('Para remarcação de conexão, você pode selecionar apenas uma poltrona para todas as reservas.');
                    } else {
                        this.marcarPoltrona(assento, sentido, fileira)
                    }
                }
            }
        } else {
            if (qtdMarcadas >= 10){
                showErrorMsg('Máximo de 10 reservas por pedido');

            }else{
                this.marcarPoltrona(assento, sentido, fileira)
            }
        }
    }

    montarMapaAssentos() {
        this.montarMapaAssentosIda();
        this.montarMapaAssentosVolta();
    }

    montarMapaAssentosIda() {
        if (this.props.ida) {
            this.props.changeFieldValue('formReserva',
                'embarqueIda', this.props.ida.embarque);
            this.props.buscarMapaVeiculoItinerario(this.props.ida.idItinerario, this.props.origem.id, this.props.destino.id, true, this.props.ida.tipoVeiculo);
        }
    }

    montarMapaAssentosVolta() {
        if (this.props.volta) {
            this.props.changeFieldValue('formReserva',
                'embarqueVolta', this.props.volta.embarque);
            this.props.buscarMapaVeiculoItinerario(this.props.volta.idItinerario, this.props.destino.id, this.props.origem.id, false, this.props.volta.tipoVeiculo);
        }
    }

    calcularValorTotalFormatado() {
        return this.calcularValorTotal().toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
    }

    exibirAssentesSelecionados() {
        const style = {
            backgroundColor: 'rgb(250, 141, 66)',
            borderRadius: '8px',
            padding: '8px',
            width: '35px',
            textAlign: 'center',
            border: '1px solid rgb(250, 141, 66)'
        };
        if (this.props.poltronasSelecionadas === null || this.props.poltronasSelecionadas.length === 0) {
            return ''
        }
        return (
            <div className='row col-12'>
                <div className="col-12 col-sm- col-md-4">
                    <p>Poltronas selecionadas: </p>
                    {this.props.poltronasSelecionadas.map(pol => <label className='ml-1' style={style} key={pol.id}>
                        <span>{pol.numero}</span>
                    </label>)}
                </div>
                <div className='col-md-4' />
                <div className="col-12 col-sm-4 col-md-4">
                    <label><strong>Valor total : {this.calcularValorTotalFormatado()}</strong></label>
                </div>

            </div>
        )
    }

    render() {
        return (
            <div className='mt-4 col-md-12'>
                {this.props.mapaVeiculoItinerarioIda.length ? <MapaVeiculoItinerario
                    selecionar={this.selecionarAssentoItinerarioIda.bind(this)}
                    mapaVeiculo={this.props.mapaVeiculoItinerarioIda}
                    idItinerario={this.props.ida.idItinerario}
                    exibeBotoesRedirecionamento
                    nomePrestador={this.props.ida.nomePrestador}
                    sentido='IDA' trecho={`${this.props.origem.nomeComUf} -> ${this.props.destino.nomeComUf}`}
                    data={moment(this.props.ida.dataHoraPartida).format('DD/MM/YY HH:mm')}
                    dataChegada={moment(this.props.ida.dataHoraChegada).format('DD/MM/YY HH:mm')} /> : ''}
                {this.props.mapaVeiculoItinerarioVolta.length
                    ? <MapaVeiculoItinerario selecionar={this.selecionarAssentoItinerarioVolta.bind(this)}
                        mapaVeiculo={this.props.mapaVeiculoItinerarioVolta}
                        sentido='VOLTA'
                        nomePrestador={this.props.ida.nomePrestador}
                        exibeBotoesRedirecionamento
                        idItinerario={this.props.volta.idItinerario}
                        trecho={`${this.props.destino.nomeComUf} -> ${this.props.origem.nomeComUf}`}
                        data={moment(this.props.volta.dataHoraPartida).format('DD/MM/YY HH:mm')}
                        dataChegada={moment(this.props.volta.dataHoraChegada).format('DD/MM/YY HH:mm')} /> : ''}
                {this.exibirAssentesSelecionados()}
            </div>
        )
    }
}


export const mapStateToProps = state => (
    {
        ida: state.viagemIda,
        volta: state.viagemVolta,
        poltronasSelecionadas: state.poltronasSelecionadas,
        origem: state.origem,
        destino: state.destino,
        passageiros: state.passageiros,
        mapaVeiculoItinerarioIda: state.mapaVeiculoItinerarioIda,
        mapaVeiculoItinerarioVolta: state.mapaVeiculoItinerarioVolta,
        dataIda: state.dataIda,
        dataVolta: state.dataVolta,
        passageirosIda: state.passageirosIda,
        passageirosVolta: state.passageirosVolta,
        viagemIda: state.viagemIda,
        viagemVolta: state.viagemVolta,
        bloqueioPoltronasTemporario: state.bloqueioPoltronasTemporario,
        reservasSelecionadas: state.remarcacao.reservasSelecionadas,
        empresaSelecionada: state.empresaSelecionada

    });


export default connect(mapStateToProps,
    {
        buscarItinerarios,
        excluirItinerarios,
        buscarRotas,
        changeFieldValue,
        buscarVeiculos,
        buscarMapaVeiculoItinerario,
        selecionarPoltronas,
        selecionarAssentoItinerarioIda,
        selecionarAssentoItinerarioVolta,
        adicionarPassageirosIda,
        adicionarPassageirosVolta,
        adicionarFormasPagamento,
        liberarBloqueioPoltronasTemporario,
        criarBloqueioPoltronasTemporario,
        verificarItinerarioAtivoOuInativo,
        bloquearPoltronaJaMarcadoItinerarioIda,
        bloquearPoltronaJaMarcadoItinerarioVolta
    })(reduxForm({
        form: 'formReserva',
        enableReinitialize: true,
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
    })(AbaSelecionarPoltrona))
